<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
    <DialogShowShareStatistik ref="dlgShareStats"></DialogShowShareStatistik>
    <v-dialog v-model="dialog" scrollable width="90%">
        <v-card>
            <v-card-title>
                Veranstalter Playlisten diesen Standorten hinzufügen
            </v-card-title>
            <v-card-text>
                <v-layout row wrap justify-start>
                    <v-row>
                        <v-col cols="12" xs="12">
                            <v-select
                                    v-model="companyId"
                                    :items="deviceList"
                                    outlined
                                    @change="reloadLocations"
                                    item-value="guid"
                                    item-text="name"
                                    label="Netzwerk wählen"
                            ></v-select>
                        </v-col>
                        <v-col cols="12" xs="12">
                            <TableStandorte ref="tableStandorte" :showTitle="false" :companyId="companyId" :isCompanyView="true"/>
                        </v-col>
                    </v-row>
                </v-layout>

            </v-card-text>
            <v-card-actions>
                <v-btn @click="doCancel()" color="red darken-4" small dark outlined
                       class="radiusBtn text-none">Abbrechen
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn @click="doShare()" color="red darken-4" small dark outlined
                       class="radiusBtn text-none">Verteilen
                </v-btn>

            </v-card-actions>
        </v-card>
    </v-dialog>
    </div>
</template>

<script>
    import Vue from 'vue'
    import TableStandorte from './../../tables/TableStandorte'
    import DialogShowShareStatistik from './DialogShowShareStatistik'
    var _ = require('lodash')

    export default {
        name: 'DialogSharePlaylistsOnCompanies',
        components: {TableStandorte, DialogShowShareStatistik},
        methods: {
            doCancel: function () {
                this.dialog = false
                this.$emit('cancel', null)
            },
            doSave: function () {
                this.dialog = false
                this.$emit('save', this.selected)
            },
            onShareDone: function (stats) {
                console.log('onShareDone', stats)
                this.$refs['dlgShareStats'].open({title: 'Statistik', description: '', data: stats})
            },
            doShare: function () {
                console.log('doShare')
                let list = this.$refs.tableStandorte.getSelected()
                if (list && this.itemToShare) {
                    let companies = []
                    _.forEach(list, function (company) {
                        companies.push(company.guid)
                    })
                    Vue.prototype.$api.sharePlayListToCompanies(this.companyId, this.itemToShare.guid, companies, this.onShareDone)
                }
            },
            select: function (item) {
                console.log('onSelect', item)
                this.dialog = false
                this.$emit('save', item)
            },
            open: function (cardConfig) {
                if ((cardConfig != null) && (cardConfig)) {
                    this.title = cardConfig.title
                    this.description = cardConfig.description
                    this.itemToShare = cardConfig.itemToShare
                }
                this.companyId = '-999'
                this.reload()
                this.dialog = true
                let cmp = this
                this.$nextTick(function () {
                    cmp.reloadLocations()
                })

            },
            reloadLocations: function () {
                let cmp = this

                Vue.prototype.$api.getLocationsWherePlayListLinked(this.itemToShare.guid, this.companyId, this.onGetSelectedLocations)

                if (this.$refs.tableStandorte) {
                    cmp.$refs.tableStandorte.reloadWithParentId(this.companyId)
                }
            },
            onGetSelectedLocations: function (locations) {
                console.log('onGetSelectedLocations', locations)
                if (this.$refs.tableStandorte) {
                    this.$refs.tableStandorte.setSelected(locations)
                }

            },
            reload: function () {
                var reqData = {
                    isMother: 1
                    // typ: 0
                }
                Vue.prototype.$apiCompany.loadCompanies(reqData, this.onGetData)
            },
            toMB: function (bytes, decimals) {
                if (bytes == 0) return '0 Bytes';
                var k = 1024,
                    dm = decimals <= 0 ? 0 : decimals || 2,
                    sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
                    i = Math.floor(Math.log(bytes) / Math.log(k));
                return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
            },
            onGetData: function (result) {
                console.log('result', result)
                this.deviceList = result
            }
        },
        data() {
            return {
                tab: 1,
                itemToShare: null,
                headers: [
                    {text: 'Name', align: 'left', value: 'name'},
                    {text: 'Adresse', value: 'address'},
                    /*{text: 'Strasse', value: 'street'},
                    {text: 'PLZ', value: 'postcode'},
                    {text: 'Stadt', value: 'city'},*/
                    {text: 'E-Mail', value: 'email'},
                    {text: 'Telefon', value: 'phonenumber'},
                    {text: 'Aktion', value: 'action'}
                    /*{text: 'Erstellt', value: 'created'},
                    {text: 'Kommentar', value: 'comment'}
                     */
                ],
                selected: [],
                search: '',
                companyId: null,
                deviceList: [],
                title: 'Login nicht erfolgreich',
                description: 'Wir konnten die Kombination aus Username und Passwort nicht validieren',
                dialog: false
            }
        },
        mounted() {
        }
    }
</script>

<style scoped>

</style>
